import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import Home from './views/home/Page.vue'
import PointOfSale from './views/point-of-sale/Page'
import HomepageSettings from './views/homepage-settings/Page'
import { PromotionPage } from '@fixit/promotion-pages'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        breadcrumb: [{ name: 'Innstillinger' }]
      },
      props: (route) => {
        let addOns = route.query.addons !== undefined ? route.query.addons : route.query['add-ons']
         return {
           showAddOns: addOns !== undefined && addOns !== 'false'
         }
      }
    },
    {
      path: '/point-of-sale',
      name: 'point-of-sale',
      component: PointOfSale,
      meta: {
        breadcrumb: [{ name: 'Innstillinger', page: 'home' }, { name: 'Kasse' }]
      }

    },
    // Promotion pages
    {
      path: '/promotion/:name',
      alias: '/promotering/:name',
      name: 'promotion',
      component: PromotionPage,
      props: true,
      meta: {
        breadcrumb: [{ name: 'Innstillinger', page: 'home' }, { name: 'Kom i gang' }]
      }
    },
    // Promotion pages
    {
      path: '/hjemmeside-innstillinger/:section?/:subsection?',
      alias: '/homepagesettings',
      name: 'homepage-settings',
      component: HomepageSettings,
      props: true,
      beforeEnter: (to, from, next) => {
        if (!to.params.section) {
          next({
            name: 'homepage-settings',
            params: {
              section: 'innstillinger',
              subsection: null
            }
          })
        } else {
          next()
        }
      },
      meta: {
        breadcrumb: [{ name: 'Innstillinger', page: 'home' }, { name: 'Kom i gang' }]
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.hash) {
    window.location.reload()
  } else {
    // Set breadcrumbs
    let breadcrumbs = to.meta.breadcrumb || []
    store.commit('breadcrumbs/setItems', breadcrumbs)
    next()
  }
})

export default router
